module.exports = __webpack_public_path__ + "static/7-1b484378936ec83366b923c2d1ed4675.jpg";